var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-img',_vm._b({attrs:{"src":require(`../../assets/platform-logo-${_vm.platform}.png`),"alt":"logo"}},'b-img',_vm.logoProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }